// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as jsxRuntime from "react/jsx-runtime";
export function BadgeTooltip({
  anchor: u,
  title: o,
  description: m,
  onClose: r
}) {
  const g = React.useRef(null),
    [j, B] = React.useState(null);
  return React.useLayoutEffect(() => {
    const U = g.current;
    if (!U) return;
    const N = u.getBoundingClientRect(),
      y = U.getBoundingClientRect(),
      X = 12,
      M = 9,
      R = N.left + N.width / 2,
      H = Math.max(X, Math.min(R - y.width / 2, window.innerWidth - y.width - X)),
      Y = u.closest(".mc-profile-badges")?.getBoundingClientRect(),
      P = Math.max(N.bottom, Y?.bottom ?? N.bottom) + M,
      W = P + y.height <= window.innerHeight - X ? "below" : "above",
      ee = W === "below" ? P : Math.max(X, N.top - M - y.height);
    B({
      left: H,
      top: ee,
      arrow: Math.max(14, Math.min(R - H, y.width - 14)),
      side: W
    });
  }, [u, o, m]), React.useEffect(() => {
    const U = y => {
        y.target instanceof Node && !u.contains(y.target) && !g.current?.contains(y.target) && r();
      },
      N = y => {
        y.key === "Escape" && r();
      };
    return document.addEventListener("pointerdown", U), document.addEventListener("keydown", N), window.addEventListener("resize", r), window.addEventListener("scroll", r, !0), () => {
      document.removeEventListener("pointerdown", U), document.removeEventListener("keydown", N), window.removeEventListener("resize", r), window.removeEventListener("scroll", r, !0);
    };
  }, [u, r]), ReactDOM.createPortal(jsxRuntime.jsxs("div", {
    ref: g,
    id: "mc-profile-badge-details",
    className: "mc-profile-badge-tip",
    role: "tooltip",
    "data-side": j?.side,
    style: {
      left: j?.left ?? 0,
      top: j?.top ?? 0,
      visibility: j ? "visible" : "hidden",
      "--badge-tip-arrow": `${j?.arrow ?? 0}px`
    },
    children: [jsxRuntime.jsx("strong", {
      children: o
    }), jsxRuntime.jsx("p", {
      children: m
    })]
  }), document.body);
}
